import {
  ErrorCodes,
  IPersonalInfoCmsMobile,
  IPortabilityMobileCMS,
  IProduct,
} from '@vfit/consumer/data-access';
import { ErrorDetail } from '@vfit/shared/data-access';
import { IGenericError } from '@vfit/shared/models';
import { purify } from '@vfit/shared/themes';

export const checkError = (
  errorCode: string,
  handleOnClose: (() => void) | undefined,
  errorMessge: IGenericError
): ErrorDetail => {
  const title = errorMessge?.title || '';
  let message = errorMessge?.description || '';
  const actionText = errorMessge?.buttonLabel || '';
  let onClose: (() => void) | undefined = handleOnClose;
  let actionEvent: (() => void) | undefined = handleOnClose;
  if (errorCode === ErrorCodes.FISCAL_CODE_UNDERAGE) {
    message = 'Devi essere maggiorenne per proseguire';
    onClose = undefined;
    actionEvent = undefined;
  }
  if (errorCode === ErrorCodes.FISCAL_CODE_ERROR) {
    message = 'Il codice fiscale non è valido. Inserisci un codice fiscale valido per proseguire';
    onClose = undefined;
    actionEvent = undefined;
  }
  return {
    title,
    message,
    actionText,
    onClose,
    actionEvent,
  };
};

export const organizeNameFiscalCodeMobile = (
  nameFiscalCodeCms: IPersonalInfoCmsMobile,
  product?: IProduct | null
) => ({
  title: nameFiscalCodeCms?.personalinfomobile?.firstCard?.title || '',
  description: nameFiscalCodeCms?.personalinfomobile?.firstCard?.description || '',
  firstNameLable: nameFiscalCodeCms?.personalinfomobile?.selectInput?.firstName || '',
  lastNameLable: nameFiscalCodeCms?.personalinfomobile?.selectInput?.lastName || '',
  fiscalCodeLable: nameFiscalCodeCms?.personalinfomobile?.selectInput?.fiscalCode || '',
  buttonLabel: nameFiscalCodeCms?.personalinfomobile?.firstCard?.fcMissingLabel || '',
  legacyPopup: {
    legacyPopupIsOpen: true,
    legacyPopupTitle:
      product?.commonOverride?.legacyCtc?.title ||
      nameFiscalCodeCms?.personalinfomobile?.clientRecognition?.redirect?.title ||
      '',
    legacyPopupMessage:
      product?.commonOverride?.legacyCtc?.description ||
      nameFiscalCodeCms?.personalinfomobile?.clientRecognition?.redirect?.description ||
      '',
    legacyPopupActionText:
      product?.commonOverride?.legacyCtc?.buttonLabel ||
      nameFiscalCodeCms?.personalinfomobile?.clientRecognition?.redirect?.buttonLabel ||
      '',
    legacyPopupUrl: product?.commonOverride?.legacyCtc?.buttonLabel
      ? product?.commonOverride?.legacyCtc?.url || ''
      : product?.commonOverride?.legacyCtc?.url ||
        nameFiscalCodeCms?.personalinfomobile?.clientRecognition?.redirect?.url ||
        '',
  },
});

export const organizePrsonalInfoMobile = (dataFromCms: IPersonalInfoCmsMobile) => ({
  title: dataFromCms?.personalinfomobile?.clientLogged?.personalInfo?.title || '',
  description: dataFromCms?.personalinfomobile?.clientLogged?.personalInfo?.description || '',
  bottomText: dataFromCms?.personalinfomobile?.clientLogged?.personalInfo?.bottomText || '',
  lableName: dataFromCms?.personalinfomobile?.clientLogged?.personalInfo?.labelName || '',
  lableFiscalCode:
    dataFromCms?.personalinfomobile?.clientLogged?.personalInfo?.lableFiscalCode || '',
  action: dataFromCms?.personalinfomobile?.clientLogged?.personalInfo?.textAction || 'Logout',
  url:
    dataFromCms?.personalinfomobile?.clientLogged?.personalInfo?.url ||
    'https://www.vodafone.it/accediavodafone/accedi.html',
});

export const organizeRetriveFiscalCodeMobile = (
  nameFiscalCodeCms: IPersonalInfoCmsMobile,
  portabilityCardCms: IPortabilityMobileCMS,
  isSkipMnp?: boolean
) => ({
  retriveFiscalCode: {
    title: nameFiscalCodeCms?.personalinfomobile?.fiscalCode?.title || '',
    description: nameFiscalCodeCms?.personalinfomobile?.fiscalCode?.description || '',
    firstName: nameFiscalCodeCms?.personalinfomobile?.selectInput?.firstName || '',
    lastName: nameFiscalCodeCms?.personalinfomobile?.selectInput?.lastName || '',
    birthDate: nameFiscalCodeCms?.personalinfomobile?.selectInput?.birthdate || '',
    gender: nameFiscalCodeCms?.personalinfomobile?.selectInput?.gender || '',
    nationality: nameFiscalCodeCms?.personalinfomobile?.selectInput?.country || '',
    birthPlace: nameFiscalCodeCms?.personalinfomobile?.selectInput?.city || '',
    birthNation:
      nameFiscalCodeCms?.personalinfomobile?.selectInput?.birthNation || 'Nazione di nascita',
    errorMessage: nameFiscalCodeCms?.personalinfomobile?.firstCard?.allFieldsAreRequired || '',
    buttonLabel: nameFiscalCodeCms?.personalinfomobile?.fiscalCode?.buttonLabel || '',
  },
  nameFiscalCodeCard: {
    title: nameFiscalCodeCms?.personalinfomobile?.firstCard?.title || '',
    titleReadOnly:
      nameFiscalCodeCms?.personalinfomobile?.firstCard?.titleReadOnly ||
      nameFiscalCodeCms?.personalinfomobile?.firstCard?.title ||
      '',
    description: nameFiscalCodeCms?.personalinfomobile?.firstCard?.description || '',
    descriptionReadOnly:
      nameFiscalCodeCms?.personalinfomobile?.firstCard?.descriptionReadOnly ||
      nameFiscalCodeCms?.personalinfomobile?.firstCard?.description ||
      '',
    firstNameLable: nameFiscalCodeCms?.personalinfomobile?.selectInput?.firstName || '',
    lastNameLable: nameFiscalCodeCms?.personalinfomobile?.selectInput?.lastName || '',
    fiscalCodeLable: nameFiscalCodeCms?.personalinfomobile?.selectInput?.fiscalCode || '',
    buttonLabel: nameFiscalCodeCms?.personalinfomobile?.firstCard?.fcMissingLabel || '',
  },
  howToModalCard: {
    title: isSkipMnp ? '' : portabilityCardCms?.portabilitymobile?.howToModal?.label || '',
    description: portabilityCardCms?.portabilitymobile?.howToModal?.description || '',
  },
});

export const getCmsValidationConfig = (
  dataFromCms?: IPersonalInfoCmsMobile
): {
  requiredField?: string;
  validFiscalCode?: string;
  validName?: string;
  validSurname?: string;
  surnameMinLen?: string;
  validDate?: string;
  nameMinLen?: string;
} => {
  const validations = dataFromCms?.editorialconfigs?.elements || [];
  const getValidationByID = (id: string) => {
    const parser = new DOMParser();
    const value = validations?.find((e) => e.id === id)?.value || '';
    const doc = parser.parseFromString(purify([value || ''])?.[0] || '', 'text/html');
    return doc.body.textContent || '';
  };
  return {
    requiredField: getValidationByID('requiredField'),
    validFiscalCode: getValidationByID('validFiscalCode'),
    validName: getValidationByID('validName'),
    validSurname: getValidationByID('validSurname'),
    surnameMinLen: getValidationByID('surnameMinLen'),
    validDate: getValidationByID('validDate'),
    nameMinLen: getValidationByID('nameMinLen'),
  };
};

